// The client this deployment renders (CareWorks, Bonitas, ...) is set per EB
// environment via the `client_name` env var, injected at container start into
// /runtime-config.js (see default.conf.template). Falls back to "careworks" for
// local dev, where that script isn't served.
export function getClientName() {
  return (window.__APP_CONFIG__ && window.__APP_CONFIG__.clientName) || "careworks";
}
